import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IUplaod = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
          >
            <path
              d="M16 0H2C0.89 0 0 0.9 0 2V14C0 15.1 0.89 16 2 16H6V14H2V4H16V14H12V16H16C17.1 16 18 15.1 18 14V2C18 0.9 17.11 0 16 0ZM9 6L5 10H8V16H10V10H13L9 6Z"
              fill="#37474F"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IUplaod;
